<nav
  aria-label="Tabs"
  [className]="className"
  [ngClass]="{
    '-mb-px flex overflow-x-auto overflow-y-hidden border-b border-gray-200': isClassicVariant,
    'space-x-8': (isFullPage$ | async) === false && isClassicVariant,
    'divide-x': (isFullPage$ | async) === true && isClassicVariant,
  }"
>
  @if ({ tabs: tabs$ | async, activeIndex: activeIndex$ | async }; as obj) {
    @for (tab of obj.tabs; track tab; let index = $index) {
      @if (isClassicVariant && (tab.show ? (tab.show | async) : true)) {
        <button
          type="button"
          class="flex items-center whitespace-nowrap text-sm font-medium focus:outline-none"
          [routerLink]="tab.route"
          [ngClass]="{
            'border-b-2 px-1 py-4': (isFullPage$ | async) === false,
            'my-4 px-4': (isFullPage$ | async) === true,
            'border-aux-blue-light text-aux-blue-light':
              (isFullPage$ | async) === false && index === obj.activeIndex,
            'border-transparent text-gray-500':
              (isFullPage$ | async) === false && index !== obj.activeIndex,
            'font-bold text-aux-black': (isFullPage$ | async) === true && index === obj.activeIndex,
            'text-aux-blue underline': (isFullPage$ | async) === true && index !== obj.activeIndex,
            'hover:border-gray-300 hover:text-gray-700': index !== obj.activeIndex,
          }"
        >
          {{ tab.label }}
          @if (tab?.badge?.amount$ | async; as badgeAmount) {
            <span
              class="ml-2 flex h-6 w-6 items-center justify-center rounded-full bg-aux-error"
              [auxTooltip]="tab?.badge?.tooltip || ''"
            >
              <span class="text-sm font-bold text-aux-gray-light">{{ badgeAmount }}</span>
            </span>
          }
        </button>
      }
      @if (isButtonVariant && (tab.show ? (tab.show | async) : true)) {
        <button
          type="button"
          class="whitespace-nowrap rounded border-b-2 px-4 py-2 text-sm font-medium focus:outline-none"
          [routerLink]="tab.route"
          [ngClass]="{
            'border-aux-blue-light bg-aux-blue-light text-white': index === obj.activeIndex,
            'border-transparent text-gray-500 hover:text-gray-700': index !== obj.activeIndex,
          }"
        >
          {{ tab.label }}
        </button>
      }
    }
  }
</nav>
